<ion-header>
    <ion-toolbar mode="ios">
        <ion-title>{{'AddAsTemplate' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="dismiss('dismiss')">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list>
        <ion-item class="ion-margin-bottom">
            <ion-label position="stacked">{{ 'Title' | translation }}</ion-label>
            <ion-input placeholder="{{ 'WriteHere' | translation }}" [(ngModel)]="title"
                       (ngModelChange)="UpdateTitle()"></ion-input>
        </ion-item>

        <ion-button [disabled]="disabled" (click)="dismiss('add')"
                    expand="block">{{'AddAsTemplate' | translation}}</ion-button>
    </ion-list>
</ion-content>

